import type { PropsWithChildren } from 'react';
import List from '@mui/material/List';
import {
    ApproveAction,
    CommentAction,
    EditAction,
    RejectAction
} from './actions';

const ActionList = ({ children }: PropsWithChildren) => (
    <List
        dense
        disablePadding
    >
        {children ?? (
            <>
                <ApproveAction />
                <RejectAction />
                <CommentAction />
                <EditAction />
            </>
        )}
    </List>
);

export default ActionList;
